class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (this.form) {
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    this.cartNotification = document.querySelector('cart-notification');
  }

  isSelectedSwatch = () => {
    try {
      // Find the product info wrapper (parent container) or use document as fallback
      const productInfoWrapper = this.closest('.product__info-wrapper') ||
        document.querySelector('.product__info-wrapper') ||
        document;

      // Check if variant-radios component exists
      const swatchesWrapper = productInfoWrapper.querySelector('variant-radios');
      if (!swatchesWrapper) {
        // No variant picker exists, so validation passes
        return true;
      }

      // Check if any swatch is selected within the variant-radios component
      const swatch = swatchesWrapper.querySelector('.variant-swatch-input:checked');
      const errormsg = swatchesWrapper.querySelector('.product-form__input .error-msg');

      if (swatch) {
        // Swatch is selected, hide error message if it exists
        if (errormsg) {
          errormsg.classList.add("d-none");
        }
        return true;
      } else {
        // No swatch selected, show error message if it exists
        if (errormsg) {
          errormsg.classList.remove("d-none");
          setTimeout(() => {
            if (errormsg && errormsg.parentElement) {
              errormsg.classList.add("d-none");
            }
          }, 5000);
        }
        return false;
      }
    } catch (error) {
      // If any error occurs, log it and allow form submission to prevent blocking
      console.error('Error in isSelectedSwatch:', error);
      return true;
    }
  };

  showErrorMessage(message) {
    // Find error message div within product form or variant-radios
    const productInfoWrapper = this.closest('.product__info-wrapper')

    // Try to find error-msg in variant-radios first, then in product-form
    let errorMsg = productInfoWrapper.querySelector('.text-danger-add-to-cart')

    // If no error message div exists, create one
    if (!errorMsg) {
       return;
    }

    if (errorMsg) {
      errorMsg.textContent = message;
      errorMsg.classList.remove('d-none');
      // Auto-hide after 5 seconds
      setTimeout(() => {
        if (errorMsg && errorMsg.parentElement) {
          errorMsg.classList.add('d-none');
        }
      }, 5000);
    }
  }

  hideErrorMessage() {
    const productInfoWrapper = this.closest('.product__info-wrapper')

    const errorMsg = productInfoWrapper.querySelector('.text-danger-add-to-cart')

    if (errorMsg) {
      errorMsg.classList.add('d-none');
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (!this.isSelectedSwatch()) return;

    // Hide any previous error messages
    // this.hideErrorMessage();

    this.cartNotification.setActiveElement(document.activeElement);
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    // Extract form data
    const formData = JSON.parse(serializeForm(this.form));
    const variantId = parseInt(formData.id);
    const quantity = parseInt(formData.quantity) || 1;

    // Extract properties (serializeForm converts properties[Key] to properties.Key)
    const properties = formData.properties || {};

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: properties
      })
    })
      .then(async res => {
        if (!res.ok) {
          // For 422/400 etc, Shopify returns JSON with message — parse it
          const err = await res.json().catch(() => ({}));
          throw { status: res.status, body: err };
        }
        return res.json();
      })
      .then(data => {
        console.log('Added to cart:', data);

        // Hide any error messages on success
        // this.hideErrorMessage();

        // Get sections to render for cart notification
        const sectionsToRender = this.cartNotification.getCartSectionsToRender();
        const sectionIds = sectionsToRender.map(section => section.id).join(',');

        // Fetch cart notification HTML and required sections
        return Promise.all([
          fetch('/?section_id=cart-notification').then(res => res.text()),
          sectionIds ? fetch(`/?sections=${sectionIds}`).then(res => res.json()).catch(() => ({})) : Promise.resolve({})
        ])
          .then(([htmlData, sectionsData]) => {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(htmlData, 'text/html');
            const cart = htmlDoc.querySelector("cart-notification #cart-notification");
            const currentCartNotification = document.querySelector("cart-notification #cart-notification");

            // Build parsedState with sections for renderCart
            const parsedState = {
              sections: sectionsData || {}
            };

            this.cartNotification.renderCart(parsedState, {
              cartNotification: currentCartNotification,
              text: cart
            });
          });
      })
      .catch(err => {
        console.error('Add to cart failed:', err);

        // let errorMessage = 'Unable to add product to cart. Please try again.';

        // // Handle different error types
        // if (err.status === 422) {
        //   // Inventory/unavailable errors
        //   if (err.body && err.body.description) {
        //     errorMessage = err.body.description;
        //   } else if (err.body && err.body.message) {
        //     errorMessage = err.body.message;
        //   } else {
        //     errorMessage = 'This product is currently unavailable or out of stock.';
        //   }
        // } else if (err.status === 400) {
        //   errorMessage = 'Invalid request. Please check your selection and try again.';
        // } else if (err.status === 404) {
        //   errorMessage = 'Product not found. Please refresh the page and try again.';
        // } else if (!err.status) {
        //   // Network error or other issues
        //   errorMessage = 'Network error. Please check your connection and try again.';
        // }

        // // Show error message in the error-msg div
        // this.showErrorMessage(errorMessage);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }
}
customElements.define('product-form', ProductForm);